import { Fragment } from 'react';

const joinNodesReducer = (delimiter, lastDelimiter = delimiter) => (nodes, node, index, array) => {
  const itemDelimiter = index < (array.length - 1)
    ? delimiter
    : lastDelimiter;

  return nodes === null
    ? [node]
    : [...nodes, <Fragment key={index}>{itemDelimiter}</Fragment>, node];
};

export default function joinNodes(nodeArray, delimiter, lastDelimiter) {
  return nodeArray.reduce(joinNodesReducer(delimiter, lastDelimiter), null);
}
